// utils/statusUtils.js
export function getNumberStatusLabel(status) {
  switch (status) {
    case 0:
    case 3:
      return "Active";
    case 1:
      return "Cancelled";
    case 2:
      return "Others";
    case 4:
      return "Upcoming Port";
    case 5:
      return "Port Failed";
    default:
      return "Pending";
  }
}
